export const TABLET_UP_MEDIA_QUERY = '(min-width: 768px)'

export const DESKTOP_MEDIA_QUERY = '(min-width: 1280px)'
